import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=83b8a3b2&scoped=true&"
import script from "./baseInfo.vue?vue&type=script&lang=js&"
export * from "./baseInfo.vue?vue&type=script&lang=js&"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=83b8a3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b8a3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83b8a3b2')) {
      api.createRecord('83b8a3b2', component.options)
    } else {
      api.reload('83b8a3b2', component.options)
    }
    module.hot.accept("./baseInfo.vue?vue&type=template&id=83b8a3b2&scoped=true&", function () {
      api.rerender('83b8a3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/baseInfo.vue"
export default component.exports